import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from "axios"
import './register.css'

export default function Register() {

  const [username, setUsername] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState(false)
  const URL = "https://blog-jainakshat.herokuapp.com/api";

  const handleSubmit =async (e) =>{
    e.preventDefault();
    setError(false);
    try{
      const response = await axios.post(URL+"/auth/register",{
        username,
        email,
        password
      })
      response.data && window.location.replace("/login")
    }catch(err){
      setError(true)
    } 
  }
  return <div className='register'>
      <span className="registerTitle">REGISTER</span>
      <form className='registerForm' onSubmit={handleSubmit}>
        <label>Username</label>
          <input type="text" className='registerInput' placeholder='Enter Your Username...' 
            onChange={e => setUsername(e.target.value)}
          />
          <label>Email</label>
          <input type="text" className='registerInput' placeholder='Enter Your Email...'
            onChange={e => setEmail(e.target.value)}
          />
          <label>Password</label>
          <input type="password" className='registerInput' placeholder='Enter Your Password...' 
            onChange={e => setPassword(e.target.value)}
          />
            <button className="registerButton" type='submit'>Register</button>
      </form>
        <button className="registerLoginButton"> <Link className="link" to='/login'>Login</Link></button>
        {error && <span style={{color: "red", marginTop: "10px"}}>something went wrong.</span>}
  </div>;
}
